import React from 'react';
import Button from './button';
import { AiOutlineRight } from "react-icons/ai";

function Projects(props) {
    return (
        <div className='project'>
            <div className="project-title">
                <h5 data-aos="fade-right">{props.allContent.projectTitle}</h5>
            </div>
            <div className="content">
                <div dangerouslySetInnerHTML={{ __html: props.allContent.projectDesc }}></div>
            </div>
            <div className="project-media">
                <img src={props.allContent.projectImage1} alt='project media 1' />
                <img src={props.allContent.projectImage2} alt='project media 2'  />
            </div>
            <div className="btn-wrap">
                <a href={props.allContent.button.url} target="_blank" rel="noreferrer">
                    <Button
                        extraClass='btn-primary'
                        buttonText={props.allContent.button.title}
                        btnIcon={<AiOutlineRight />}
                    />
                </a>
            </div>
        </div>
    );
}

export default Projects;
